/**
 * 云盘 shareable link：仅含 yun/{code}，不含中文文件名。
 */
export function getKbWebDomain () {
  const domain = process.env.VUE_APP_DOMAIN || 'https://kb.nihaocafe.com/'
  return domain.endsWith('/') ? domain.slice(0, -1) : domain
}

export function buildYunShareableLink (code) {
  if (!code) return ''
  return `${getKbWebDomain()}/yun/${code}`
}

export function filenameFromStoragePath (path) {
  if (!path) return ''
  try {
    const decoded = decodeURIComponent(path)
    const segment = decoded.split('/').filter(Boolean).pop() || ''
    return segment.split('?')[0]
  } catch {
    const segment = String(path).split('/').filter(Boolean).pop() || ''
    return segment.split('?')[0]
  }
}

export function looksLikeFileName (name) {
  if (!name) return false
  const dotIndex = name.lastIndexOf('.')
  return dotIndex > 0 && dotIndex < name.length - 1
}
